export default "__VITE_ASSET__BML7J8Lf__"